import { IconChevronRightSmall16, IconClock16 } from '@cian/ui-kit';
import {
  IconProductHighDemand16,
  IconProductCianLogo12,
  IconProductTrust16,
  IconFinancePercent12,
  IconProductHotLeads16,
  IconComfortArmchair16,
  IconSafetySecurity16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import boltIcon from './assets/bolt.svg';
import { ELabelColor, TLabelColor } from '../../types/label';
import { ClickIcon } from '../ClickIcon';

export const labelIconMap: Partial<Record<ELabelColor, React.ReactElement | undefined>> = {
  [ELabelColor.Blue]: <IconProductCianLogo12 color="icon-main-default" />,
  [ELabelColor.OrangePercent]: <IconFinancePercent12 />,
  [ELabelColor.SimpleBlueIconed]: <ClickIcon />,
  [ELabelColor.BlueVerifiedByCian]: <IconProductTrust16 color="icon-main-default" />,
  [ELabelColor.BlueInstantBooking]: <img src={boltIcon} alt="" />,
  [ELabelColor.Purple]: <IconProductHighDemand16 />,
  [ELabelColor.Orange]: <IconComfortArmchair16 color="icon-warning-default" />,
  [ELabelColor.PurpleEarlyAccess]: <IconClock16 color="decorative-accent-purple" />,
  [ELabelColor.RedEtazhiBlackFriday]: <IconProductHotLeads16 color="icon-inverted-default" />,
  [ELabelColor.BlueCpdLabel]: <IconSafetySecurity16 color="accent-main-primary" />,
};

export const labelRightIconMap: Partial<Record<ELabelColor, React.ReactElement | undefined>> = {
  [ELabelColor.SimpleBlueIconed]: <IconChevronRightSmall16 color="icon-main-default" />,
};

export function mapLabelIcon(color: TLabelColor, isDailyrent: boolean = false): React.ReactElement | undefined {
  if (isDailyrent) {
    return undefined;
  }

  return labelIconMap[color];
}

export function mapLabelRightIcon(color: TLabelColor): React.ReactElement | undefined {
  return labelRightIconMap[color];
}
